module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2",
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "oldClass": "{'text-align-right': element.align == 'right'}"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _c('SortableList', {
    staticStyle: {
      "padding": "5px",
      "border-radius": "4px"
    },
    attrs: {
      "items": _vm.files,
      "itemWidth": "50%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var file = ref.item;

        return [_c('div', {
          staticClass: "clickable",
          staticStyle: {
            "padding": "2px 4px",
            "margin": "3px",
            "display": "flex",
            "border-radius": "8px",
            "background-color": "rgba(255,255,255,0.5)",
            "border": "solid 1px #ddd"
          }
        }, [_c('div', {
          staticClass: "pt-1 pr-1"
        }, [_c('v-icon', {
          attrs: {
            "large": "",
            "color": "blue lighten-2"
          }
        }, [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "font-size": "12px",
            "padding-top": "3px"
          }
        }, [_vm._v(_vm._s(_vm.fileNameFromStoragePath(file.url)))])])]
      }
    }, {
      key: "menu",
      fn: function(slotProps) {
        return [_c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.deleteFileFromGroup(slotProps.item)
            }
          }
        }, [_c('v-list-tile-title', [_vm._v("Delete this File")])], 1), _vm._v(" "), (slotProps.selectedItems.length > 1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.deleteSelectedFiles(slotProps.selectedItems)
            }
          }
        }, [_c('v-list-tile-title', [_vm._v("Delete " + _vm._s(slotProps.selectedItems.length) + " Selected")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "transparent",
          attrs: {
            "href": slotProps.item.url,
            "target": "_blank"
          }
        }, [_c('v-list-tile', {
          on: {
            "click": function($event) {}
          }
        }, [_c('v-list-tile-title', [_vm._v("Open")])], 1)], 1)]
      }
    }])
  })], 1)]), _vm._v(" "), (!_vm.element.value) ? _c('template', {
    slot: "right"
  }, [_c('UploadWrapper', {
    on: {
      "click": _vm.doNothing,
      "select": _vm.uploadFiles
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "color": _vm.element.color,
      "disabled": _vm.element.disabled || _vm.uploading
    }
  }, [(_vm.uploading) ? _c('v-progress-circular', {
    attrs: {
      "size": "24",
      "indeterminate": "",
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.uploading) ? _c('span', [_vm._v("Upload")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d18e2cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/controls/UploadControl.vue
// module id = 2474
// module chunks = 1